"use client";

import React, { useState, MouseEvent } from "react";

import { LinkHandler } from "@/components/common/LinkHandler";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useNavigation } from "@/hooks/useNavigation";
import theme from "@/styles/theme.mjs";
import { GA4 } from "@/utils/ga4Utils";

interface RibbonMapItem {
  copy: string;
}

const ribbonMap: Record<string, RibbonMapItem> = {
  core_tt_promo: {
    copy: "Take $10 OFF in cart with code <span class='font-dinamoBold'>TIKTOK</span>",
  },
};

interface RbbonSimpleProps {
  PROMO_VARIANT?: keyof typeof ribbonMap;
}

const RbbonSimple: React.FC<RbbonSimpleProps> = ({ PROMO_VARIANT = "core_tt_promo" }) => {
  const navigate = useNavigation();
  const [isClosed] = useState(false);

  let ribbonHtml: string | null = null;
  let ribbonHref: string | null = null;

  if (ribbonMap[PROMO_VARIANT]?.copy) {
    ribbonHtml = ribbonMap[PROMO_VARIANT].copy;
    ribbonHref = null;
  } else {
    return null;
  }

  const getRibbonAttrs = () => ({
    destination: ribbonHref,
    text: ribbonHtml ? ribbonHtml.replace(/(<([^>]+)>)/gi, "") : "",
    type: "ribbon",
    module_location: "ribbon",
  });

  const goTo = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    GA4.onMarketingCtaClicked(getRibbonAttrs());
    if (ribbonHref) {
      navigate(ribbonHref);
    }
    return false;
  };

  const content = (
    <TextElementNova
      element="p"
      text={ribbonHtml}
      className="Body-20-Dia-Normal text-center text-nova-base-black"
      styles={{
        width: "100%",
        color: theme.color.nova.base.black,
      }}
    />
  );

  return (
    <div
      style={!isClosed ? { backgroundColor: "#E8FAF7" } : { display: "none" }}
      className="text-center flex"
    >
      {ribbonHref ? (
        <LinkHandler
          onClick={goTo}
          path={ribbonHref}
          id="ribbon"
          className="Body-20-Dia-Normal text-nova-base-black text-center"
        >
          <TextElementNova text={ribbonHtml} />
        </LinkHandler>
      ) : (
        <div className="w-full">{content}</div>
      )}
    </div>
  );
};

export default RbbonSimple;
